import { jsx as _jsx } from "react/jsx-runtime";
import React from "react";
import classNames from "classnames";
import useHasVisibility from "../../Hooks/useHasVisibility";
// @ts-expect-error react ts library bug. Will be fixed when we upgrade
const FeatureVisibilityWrapper = ({ name, children, keepMounted }) => {
    const hasVisibility = useHasVisibility(Array.isArray(name) ? name : [name]);
    if (keepMounted) {
        return (_jsx("div", { className: classNames({ "d-none": !hasVisibility }), children: children }));
    }
    return hasVisibility ? children : null;
};
export default FeatureVisibilityWrapper;
